import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Unit_instanceat14thlj150z as Unit_instance,
  defineProp3hxgpk2knu2px as defineProp,
  asSequence2jzw5xbq99nu9 as asSequence,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  firstOrNull175qkyx53x0vd as firstOrNull,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$,
  copyToArray2j022khrow2yi as copyToArray,
  toString1pkumu07cwy4m as toString,
  IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$,
  repeat2w4c6j8zoq09o as repeat,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  hashCodeq5arwsb9dgti as hashCode,
  first1vi3grnpj1175 as first,
  reversed1xr88n4tvzln4 as reversed,
  firstOrNull1gk7vzkf4h3nq as firstOrNull_0,
  first58ocm7j58k3q as first_0,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lazy2hsh8ze7j6ikd as lazy,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  toMutableList3ewlpx8m5ca2q as toMutableList,
  minus1djrl64vbav3y as minus,
  toList383f556t1dixk as toList,
  addAll1k27qatfgp3k5 as addAll,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  lastOrNull12ttmaua8fxfj as lastOrNull,
} from './kotlin-kotlin-stdlib.mjs';
import {
  CoreFactory46b0ey2kmo2y as CoreFactory,
  EntityManagerImpla83sxdjwhxg6 as EntityManagerImpl,
  HierarchySystem3dwjzh9jtietj as HierarchySystem,
  ComponentDeserializerRegistry1t0hod9zg4vr9 as ComponentDeserializerRegistry,
  DeserializationInterceptorRegistryo6xua20lfv6o as DeserializationInterceptorRegistry,
  JsonSerializer24j7iub0ug4dd as JsonSerializer,
  SnapshotService3u6ccppzyz14z as SnapshotService,
  CoreServices1d8s33zxz6j84 as CoreServices,
  TransformSystem26lghyta7a9eo as TransformSystem,
  WorldColliderUpdateSystem3kld4ercvpe8u as WorldColliderUpdateSystem,
  WorldDragSurfaceUpdateSystem371cykdjmc879 as WorldDragSurfaceUpdateSystem,
  RenderSystem1xa319w4fhpum as RenderSystem,
  ConnectionParentingSystem3bmut6gfi2dkt as ConnectionParentingSystem,
  UpdateHostConnectionsSystembhyds9smxfbm as UpdateHostConnectionsSystem,
  SceneGraphSystem1h1l1r73x8815 as SceneGraphSystem,
  DisableConnectorsSystemu2ju6yqn9d81 as DisableConnectorsSystem,
  DisposeTemporaryParentSystem2fdaj61fhb7sh as DisposeTemporaryParentSystem,
  RestoreSnapRootOnChildrenOfTemporaryParentSystema0v8rm39o417 as RestoreSnapRootOnChildrenOfTemporaryParentSystem,
  ProductResizingSystem3mplym8g6liji as ProductResizingSystem,
  ViewerObjectTransformSystemksztxq365izc as ViewerObjectTransformSystem,
  ViewerPresenceSystemv67ltk72nn0r as ViewerPresenceSystem,
  ViewerObjectVisibilitySystem1jre14yw9hu5d as ViewerObjectVisibilitySystem,
  CollisionValidation1d8vdntob7pqk as CollisionValidation,
  TemporaryParentConnectionValidation35xlu8n3k6kij as TemporaryParentConnectionValidation,
  LoggerImpl39a3tj9gsxbr8 as LoggerImpl,
  LoggerState_getInstance458njkt1c1yk as LoggerState_getInstance,
  setLogModule28fol0nfx6ejr as setLogModule,
  LogLevel_DEBUG_getInstance3vox4wckmki76 as LogLevel_DEBUG_getInstance,
  LogLevel_INFO_getInstance2t7zae538qncw as LogLevel_INFO_getInstance,
  LogLevel_WARN_getInstance343yembho3ik6 as LogLevel_WARN_getInstance,
  LogLevel_ERROR_getInstance203rtwgaav6kh as LogLevel_ERROR_getInstance,
  HistoryImpl2xce0gpcqs3z5 as HistoryImpl,
  addHistoryModule30wboy3cvafvx as addHistoryModule,
  ViewerComponent2txqc9jweitfp as ViewerComponent,
  Companion_instance1jc5thgshmt53 as Companion_instance,
  Core163cx1hmrsdyy as Core,
  CoreModules31i8kbsjf5lph as CoreModules,
  ProductComponent1yv8c90lajg3y as ProductComponent,
  SnapRootComponent157nyaf19ls92 as SnapRootComponent,
  get_isConnectionRoot7v6e5jlx4v0s as get_isConnectionRoot,
  Companion_instance180k82anvpmzv as Companion_instance_0,
  Companion_getInstance2hofax3pdsu41 as Companion_getInstance,
  Companion_getInstance1gt5uaft3z0z9 as Companion_getInstance_0,
  Companion_getInstance2xkh7h77bkjex as Companion_getInstance_1,
  Companion_instance25yt7vv7tdvma as Companion_instance_1,
  AssemblyPart110oq599i90v0 as AssemblyPart,
  Companion_instance3tmi9s9ict1md as Companion_instance_2,
  Companion_getInstance6pc1oksqwnwt as Companion_getInstance_2,
  createEntity38qxv713nv91g as createEntity,
  createEntityInternal3sy7rebiufsru as createEntityInternal,
  get_productRefzq8sc1a3ab3b as get_productRef,
  productSpecificationtqv6dy51ctkj as productSpecification,
  createFromSpecification2g8y2k4pnelai as createFromSpecification,
  createFromSpecificationInternal1cvmjoa6o87lg as createFromSpecificationInternal,
  ProductManager3q354ka8inlkt as ProductManager,
  SystemBase23pr0o2du1qmtu as SystemBase2,
  Companion_instanceauu711mmnozu as Companion_instance_3,
  Companion_getInstanceuteiyw5uqdpa as Companion_getInstance_3,
  InSceneComponentde0noxkj1mf1 as InSceneComponent,
  UpdatedFromSnapshotEventComponent2v4gcwwpi6res as UpdatedFromSnapshotEventComponent,
  get_serializabletahhnzjs6wap as get_serializable,
  Component1lglqnbx5ofkj as Component,
  DisplayNameComponent37eao6dtqdntj as DisplayNameComponent,
  ParentComponentw4nmaz0u9znx as ParentComponent,
  StaticComponent1ujjt0txbrs9g as StaticComponent,
  SceneComponent_instance2m1l3aroyspd4 as SceneComponent_instance,
  Companion_instanceddwlqwaeornb as Companion_instance_4,
  get_children2vj8fy0vljjod as get_children,
  get_parentComponent913cs0fasf9z as get_parentComponent,
  get_hierarchy1sm75rhmsdka0 as get_hierarchy,
  ChildComponent2d030zd3zomve as ChildComponent,
  SerializableRootComponentxsenof7kab27 as SerializableRootComponent,
  Companion_getInstancec46jiz25vrpc as Companion_getInstance_4,
  SceneReloadingComponentwzkuihaopsg1 as SceneReloadingComponent,
  Companion_instance1te2lwe2zlow7 as Companion_instance_5,
  get_descendantser7rkq0rhyf2 as get_descendants,
  SceneManager1lgs33hi6mjvz as SceneManager,
  Companion_getInstance3fuwx9k23axgp as Companion_getInstance_5,
  Companion_getInstance3c0i746p2b3f1 as Companion_getInstance_6,
  get_parent37cf1epzwukp7 as get_parent,
  Companion_getInstance27n1ww8f1u0xr as Companion_getInstance_7,
  Companion_getInstance2iuuydg1ibw9a as Companion_getInstance_8,
  Companion_getInstance3fu6fg4j4924q as Companion_getInstance_9,
  Companion_getInstance7d85wexjlmvm as Companion_getInstance_10,
  Companion_getInstance38ogszviws7a1 as Companion_getInstance_11,
  Companion_getInstancewxeheznrq82z as Companion_getInstance_12,
  ComponentDeserializer3gfn2wcyjz4fh as ComponentDeserializer,
  ValidationMode_STATE_getInstance3a0ooc1lbbllq as ValidationMode_STATE_getInstance,
  ValidationResultType_FAIL_getInstance3pxpfo6jduhaj as ValidationResultType_FAIL_getInstance,
  ValidationMode_SNAP_getInstance21t2mc3d7bdcn as ValidationMode_SNAP_getInstance,
  SnapValidationResult161dacj8es0md as SnapValidationResult,
  validateSnapCandidate1igtax04zblqe as validateSnapCandidate,
  validateSnapff2l1bo2nula as validateSnap,
  validateSnapCandidates21n6ndxamwgpm as validateSnapCandidates,
  validateSnapsjtiki3vjf94w as validateSnaps,
  validateCurrentState326fpy262zjc4 as validateCurrentState,
  ValidSnapActionCandidateOrErrors1t6fsuepjdmhc as ValidSnapActionCandidateOrErrors,
  ValidationResultType_WARNING_getInstance3uf8cr4ggrfxr as ValidationResultType_WARNING_getInstance,
  getFirstValidSnap2i0qt6mg9a6o2 as getFirstValidSnap,
  ValidationServicen25cawrb3gnh as ValidationService,
} from './core-core-api.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(CoreFactoryImpl, 'CoreFactoryImpl', CoreFactoryImpl, VOID, [CoreFactory]);
initMetadataForClass(CoreImpl, 'CoreImpl', CoreImpl, VOID, [Core]);
initMetadataForClass(CoreModulesImpl, 'CoreModulesImpl', VOID, VOID, [CoreModules]);
initMetadataForCompanion(Companion);
initMetadataForClass(ProductManagerImpl, 'ProductManagerImpl', VOID, VOID, [ProductManager]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SystemGraphViewer, 'SystemGraphViewer');
initMetadataForCompanion(Companion_1);
initMetadataForClass(SceneManagerCacheClearingSystem, 'SceneManagerCacheClearingSystem', VOID, SystemBase2);
initMetadataForCompanion(Companion_2);
initMetadataForClass(SceneManagerCacheComponent, 'SceneManagerCacheComponent', VOID, VOID, [Component]);
initMetadataForClass(SceneManagerEntitiesCache, 'SceneManagerEntitiesCache');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SceneManagerImpl, 'SceneManagerImpl', VOID, VOID, [SceneManager]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(SceneSerializationUtil, 'SceneSerializationUtil', SceneSerializationUtil);
initMetadataForClass(CoreComponentDeserializer, 'CoreComponentDeserializer', CoreComponentDeserializer, VOID, [ComponentDeserializer]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(ValidationServiceImpl, 'ValidationServiceImpl', ValidationServiceImpl, VOID, [ValidationService]);
//endregion
function CoreFactoryImpl() {
}
protoOf(CoreFactoryImpl).createNewCoreInstance = function () {
  return new CoreImpl();
};
function CoreImpl$lambda($sceneManager) {
  return function () {
    return $sceneManager.scene;
  };
}
function CoreImpl(initialSceneManager, validationService, entityManager) {
  initialSceneManager = initialSceneManager === VOID ? null : initialSceneManager;
  validationService = validationService === VOID ? new ValidationServiceImpl() : validationService;
  entityManager = entityManager === VOID ? new EntityManagerImpl() : entityManager;
  entityManager.registerSystem(new HierarchySystem(entityManager));
  var sceneManager = initialSceneManager == null ? new SceneManagerImpl(entityManager) : initialSceneManager;
  this.q3i_1 = new CoreModulesImpl(sceneManager);
  var componentSerializationRegistry = new ComponentDeserializerRegistry();
  var interceptorRegistry = new DeserializationInterceptorRegistry();
  var productManager = new ProductManagerImpl(entityManager, interceptorRegistry, CoreImpl$lambda(sceneManager));
  var serializer = new JsonSerializer(productManager, interceptorRegistry);
  var coreFactory = new CoreFactoryImpl();
  var snapshotService = new SnapshotService(entityManager, sceneManager);
  this.p3i_1 = new CoreServices(this.modules, entityManager, sceneManager, componentSerializationRegistry, interceptorRegistry, validationService, serializer, productManager, snapshotService, coreFactory);
  entityManager.registerSystem(new TransformSystem());
  entityManager.registerSystem(new WorldColliderUpdateSystem());
  entityManager.registerSystem(new WorldDragSurfaceUpdateSystem());
  entityManager.registerSystem(new RenderSystem());
  entityManager.registerSystem(new ConnectionParentingSystem());
  entityManager.registerSystem(new UpdateHostConnectionsSystem());
  entityManager.registerSystem(new SceneGraphSystem(sceneManager));
  entityManager.registerSystem(new DisableConnectorsSystem());
  entityManager.registerSystem(new DisposeTemporaryParentSystem());
  entityManager.registerSystem(new RestoreSnapRootOnChildrenOfTemporaryParentSystem());
  entityManager.registerSystem(new ProductResizingSystem(productManager));
  this.p3i_1.componentDeserializerRegistry.register(new CoreComponentDeserializer());
  entityManager.registerSystem(new ViewerObjectTransformSystem());
  entityManager.registerSystem(new ViewerPresenceSystem(entityManager));
  entityManager.registerSystem(new ViewerObjectVisibilitySystem());
  this.addValidation(new CollisionValidation());
  this.addValidation(new TemporaryParentConnectionValidation());
}
protoOf(CoreImpl).z1j = function () {
  return this.p3i_1;
};
protoOf(CoreImpl).a1k = function () {
  return this.q3i_1;
};
protoOf(CoreImpl).addValidation = function (validation) {
  this.p3i_1.validations.register(validation);
};
protoOf(CoreImpl).removeValidation = function (validation) {
  this.p3i_1.validations.unregister(validation);
};
protoOf(CoreImpl).getValidations = function () {
  return this.p3i_1.validations.validations;
};
protoOf(CoreImpl).x1j = function (logger, basePackageName) {
  var nonNullLogger = logger == null ? new LoggerImpl() : logger;
  var tmp = LoggerState_getInstance();
  tmp.o2u(nonNullLogger, basePackageName == null ? '' : basePackageName);
};
protoOf(CoreImpl).setLogLevel = function (level) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  switch (level.toUpperCase()) {
    case 'DEBUG':
      LoggerState_getInstance().n2u(LogLevel_DEBUG_getInstance());
      break;
    case 'INFO':
      LoggerState_getInstance().n2u(LogLevel_INFO_getInstance());
      break;
    case 'WARN':
      LoggerState_getInstance().n2u(LogLevel_WARN_getInstance());
      break;
    case 'ERROR':
      LoggerState_getInstance().n2u(LogLevel_ERROR_getInstance());
      break;
    default:
      LoggerState_getInstance().n2u(LogLevel_INFO_getInstance());
      break;
  }
};
protoOf(CoreImpl).y1j = function (history, historySize) {
  var nonNullHistory = history == null ? new HistoryImpl(this.p3i_1.entityManager, this.p3i_1.snapshotService, historySize) : history;
  this.q3i_1.t3i(nonNullHistory);
  return nonNullHistory;
};
protoOf(CoreImpl).setViewer = function (viewer) {
  var sceneRoot = this.p3i_1.sceneManager.root;
  if (viewer == null) {
    this.p3i_1.entityManager.removeComponent(sceneRoot, Companion_instance.z1p_1);
  } else {
    this.p3i_1.entityManager.addComponent(sceneRoot, new ViewerComponent(viewer));
  }
};
protoOf(CoreImpl).version = function () {
  return 'patch';
};
function CoreModulesImpl(sceneManager) {
  this.r3i_1 = sceneManager;
  this.s3i_1 = null;
}
protoOf(CoreModulesImpl).history = function () {
  return this.s3i_1;
};
protoOf(CoreModulesImpl).viewer = function () {
  var tmp0_safe_receiver = this.r3i_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.root;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.__getComponentForKotlin(Companion_instance.z1p_1);
  return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.viewer;
};
protoOf(CoreModulesImpl).t3i = function (history) {
  this.s3i_1 = history;
};
function findProductSpecification($this, productRef, params) {
  var tmp = asSequence($this.catalogs);
  return firstOrNull(mapNotNull(tmp, ProductManagerImpl$findProductSpecification$lambda(productRef, params)));
}
function createEntityFromSpecification($this, specification, productRef, entityId) {
  var entity = entityId == null ? $this.u3i_1.createEntity() : $this.u3i_1.createEntityInternal(entityId);
  $this.u3i_1.addComponent(entity, new ProductComponent(productRef));
  addComponents($this, entity, specification.components);
  if (get_isConnectionRoot(entity)) {
    addComponent($this, entity, new SnapRootComponent());
  }
  buildAssembly($this, specification, entity, productRef);
  var newRoot = buildHierarchy($this, specification, entity);
  if (!(newRoot == null)) {
    Companion_instance_0.y1l(newRoot);
  }
  return newRoot;
}
function buildAssembly($this, specification, entity, productRef) {
  var structure = specification.findComponent(Companion_getInstance().id);
  var parts = specification.findComponent(Companion_getInstance_0().id);
  var assemblyEntityIds = specification.findComponent(Companion_getInstance_1().id);
  if (structure == null || parts == null) {
    return Unit_instance;
  }
  addComponent($this, entity, structure);
  entity.removeComponent(Companion_getInstance_0().id);
  Companion_instance_1.x1l(entity, new AssemblyPart(productRef, VOID, VOID, structure.parts), parts.t1s_1, $this, $this.u3i_1, assemblyEntityIds);
}
function buildHierarchy($this, specification, entity) {
  var tmp0_elvis_lhs = specification.findComponent(Companion_instance_2.id);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return entity;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var structure = tmp;
  var newRoot = Companion_getInstance_2().buildProductStructure(structure, $this, $this.u3i_1);
  if (!equals(newRoot, entity)) {
    $this.u3i_1.disposeEntity(entity);
  }
  return newRoot;
}
function addComponent($this, entity, component) {
  if (component == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.catalog.ProductManagerImpl.addComponent.<anonymous>' call
    $this.u3i_1.addComponent(entity, component);
  }
}
function addComponents($this, entity, components) {
  if (components == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = components.length;
    while (inductionVariable < last) {
      var element = components[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.catalog.ProductManagerImpl.addComponents.<anonymous>' call
      $this.u3i_1.addComponent(entity, element);
    }
  }
}
function Companion() {
  Companion_instance_6 = this;
  this.z3i_1 = LoggerState_getInstance().g1v('ProductManagerImpl');
}
var Companion_instance_6;
function Companion_getInstance_13() {
  if (Companion_instance_6 == null)
    new Companion();
  return Companion_instance_6;
}
function ProductManagerImpl$createEntityInternal$lambda($productRef, this$0) {
  return function () {
    return 'Product ' + $productRef + ' not recognized by any catalog. Catalogs: ' + this$0.catalogs;
  };
}
function ProductManagerImpl$findProductSpecification$lambda($productRef, $params) {
  return function (catalog) {
    return catalog.productSpecification($productRef, $params);
  };
}
function ProductManagerImpl(entityManager, interceptorRegistry, _defaultParent) {
  Companion_getInstance_13();
  this.u3i_1 = entityManager;
  this.v3i_1 = interceptorRegistry;
  this.w3i_1 = _defaultParent;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.x3i_1 = ArrayList_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_0.y3i_1 = ArrayList_init_$Create$();
}
protoOf(ProductManagerImpl).x1t = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.x3i_1;
  return copyToArray(this_0);
};
protoOf(ProductManagerImpl).defaultParent = function () {
  return this.w3i_1();
};
protoOf(ProductManagerImpl).addCatalog = function (catalog) {
  if (!catalog.thisClassIsGuaranteedToNotModifyOrQueryCoreState) {
    // Inline function 'kotlin.error' call
    var message = "You haven't read and accepted the class documentation for ProductCatalog for catalog with id: " + catalog.rangeId();
    throw IllegalStateException_init_$Create$(toString(message));
  }
  this.v3i_1.register(catalog);
  this.x3i_1.o2(0, catalog);
};
protoOf(ProductManagerImpl).removeCatalog = function (catalog) {
  this.v3i_1.unregister(catalog);
  this.x3i_1.j2(catalog);
};
protoOf(ProductManagerImpl).y1t = function (productRef, params, entityId) {
  var entity = this.createEntityInternal(productRef, params, entityId);
  if (entity == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.y3i_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.catalog.ProductManagerImpl.createEntity.<anonymous>.<anonymous>' call
      element(entity, productRef);
    }
  }
  return entity;
};
protoOf(ProductManagerImpl).z1t = function (productRef, params, entityId) {
  var specification = findProductSpecification(this, productRef, params);
  if (specification == null) {
    var tmp = Companion_getInstance_13().z3i_1;
    tmp.warn(ProductManagerImpl$createEntityInternal$lambda(productRef, this));
    return null;
  }
  var entity = createEntityFromSpecification(this, specification, productRef, entityId);
  return entity;
};
protoOf(ProductManagerImpl).notifyCreatedListeners = function (entity) {
  var tmp0_safe_receiver = get_productRef(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.y3i_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.catalog.ProductManagerImpl.notifyCreatedListeners.<anonymous>.<anonymous>' call
      element(entity, tmp0_safe_receiver);
    }
  }
};
protoOf(ProductManagerImpl).subscribeProductCreated = function (callback) {
  this.y3i_1.h(callback);
};
protoOf(ProductManagerImpl).unsubscribeProductCreated = function (callback) {
  this.y3i_1.j2(callback);
};
protoOf(ProductManagerImpl).t1t = function (productRef, params) {
  return findProductSpecification(this, productRef, params);
};
protoOf(ProductManagerImpl).a1u = function (productRef, specification, entityId) {
  var entity = this.createFromSpecificationInternal(productRef, specification, entityId);
  if (entity == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.y3i_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.catalog.ProductManagerImpl.createFromSpecification.<anonymous>.<anonymous>' call
      element(entity, productRef);
    }
  }
  return entity;
};
protoOf(ProductManagerImpl).b1u = function (productRef, specification, entityId) {
  return createEntityFromSpecification(this, specification, productRef, entityId);
};
function printMe($this, listener, depth) {
  var indent = repeat(' ', depth);
  if (depth > 20) {
    var tmp = Companion_getInstance_14().a3j_1;
    tmp.info(SystemGraphViewer$printMe$lambda(indent));
  } else {
    printMe$innerPrint(indent, listener, listener.componentId);
    var tmp0_safe_receiver = listener.ownerSystem;
    printMe$traverseOuter($this, listener, depth, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.doingChangesOnComponent);
  }
}
function Companion_0() {
  Companion_instance_7 = this;
  this.a3j_1 = LoggerState_getInstance().g1v('SystemGraphViewer');
}
var Companion_instance_7;
function Companion_getInstance_14() {
  if (Companion_instance_7 == null)
    new Companion_0();
  return Companion_instance_7;
}
function printMe$innerPrint(indent, $listener, listeningOn) {
  var s = {_v: ''};
  var tmp = s._v;
  var tmp0_safe_receiver = $listener.ownerSystem;
  s._v = tmp + (indent + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' (' + Companion_instance.debugToString(listeningOn) + ') ');
  var tmp1_safe_receiver = $listener.ownerSystem;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.systemsBeforeMe;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp2_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp2_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.innerPrint.<anonymous>' call
      s._v = s._v + (' beforeme: ' + element);
    }
  }
  var tmp3_safe_receiver = $listener.ownerSystem;
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.systemsAfterMe;
  if (tmp4_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = tmp4_safe_receiver.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = tmp4_safe_receiver[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.innerPrint.<anonymous>' call
      s._v = s._v + (' afterme: ' + element_0);
    }
  }
  var tmp_0 = Companion_getInstance_14().a3j_1;
  tmp_0.info(SystemGraphViewer$printMe$innerPrint$lambda(s));
}
function printMe$traverseOuter(this$0, $listener, $depth, outgoingComponents) {
  if (outgoingComponents == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = outgoingComponents.length;
    while (inductionVariable < last) {
      var element = outgoingComponents[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.traverseOuter.<anonymous>' call
      var tmp0_safe_receiver = this$0.b3j_1.e2l().f2(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp0_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp0_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.entity.SystemGraphViewer.printMe.traverseOuter.<anonymous>.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver_0 = element_0.ownerSystem;
          var tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.id;
          var tmp1_safe_receiver = $listener.ownerSystem;
          if (!(tmp == (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id))) {
            printMe(this$0, element_0, $depth + 4 | 0);
          }
        }
      }
    }
  }
}
function SystemGraphViewer$printFor$lambda($componentId) {
  return function () {
    return 'No systems are listening for ' + $componentId;
  };
}
function SystemGraphViewer$printMe$lambda($indent) {
  return function () {
    return $indent + ' stopping here. Too deep';
  };
}
function SystemGraphViewer$printMe$innerPrint$lambda($s) {
  return function () {
    return $s._v;
  };
}
function SystemGraphViewer(em) {
  Companion_getInstance_14();
  this.b3j_1 = em;
}
protoOf(SystemGraphViewer).printFor = function (componentId) {
  var all = this.b3j_1.e2l();
  var base = all.f2(componentId);
  var tmp;
  if (base == null) {
    tmp = true;
  } else {
    // Inline function 'kotlin.collections.isEmpty' call
    tmp = base.length === 0;
  }
  if (tmp) {
    var tmp_0 = Companion_getInstance_14().a3j_1;
    tmp_0.info(SystemGraphViewer$printFor$lambda(componentId));
  } else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = base.length;
    while (inductionVariable < last) {
      var element = base[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.entity.SystemGraphViewer.printFor.<anonymous>' call
      printMe(this, element, 0);
    }
  }
};
function Companion_1() {
  this.c3j_1 = 'SceneManagerCacheSystem';
}
var Companion_instance_8;
function Companion_getInstance_15() {
  return Companion_instance_8;
}
function SceneManagerCacheClearingSystem(clearCallback) {
  SystemBase2.call(this, Companion_instance_8.c3j_1, Companion_instance_3.id, Companion_getInstance_3().q3e_1);
  this.o3j_1 = clearCallback;
}
protoOf(SceneManagerCacheClearingSystem).t32 = function (entity, newComponent) {
  this.o3j_1();
};
protoOf(SceneManagerCacheClearingSystem).v1v = function (entity, newComponent) {
  return this.t32(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(SceneManagerCacheClearingSystem).u32 = function (entity, oldComponent, newComponent) {
};
protoOf(SceneManagerCacheClearingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.u32(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(SceneManagerCacheClearingSystem).v32 = function (entity, oldComponent) {
  this.o3j_1();
};
protoOf(SceneManagerCacheClearingSystem).z1v = function (entity, oldComponent) {
  return this.v32(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
protoOf(SceneManagerCacheClearingSystem).p3j = function (entity, newComponent) {
  this.o3j_1();
};
protoOf(SceneManagerCacheClearingSystem).l1z = function (entity, newComponent) {
  return this.p3j(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(SceneManagerCacheClearingSystem).q3j = function (entity, oldComponent, newComponent) {
};
protoOf(SceneManagerCacheClearingSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.q3j(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(SceneManagerCacheClearingSystem).r3j = function (entity, oldComponent) {
};
protoOf(SceneManagerCacheClearingSystem).p1z = function (entity, oldComponent) {
  return this.r3j(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
function Companion_2() {
}
protoOf(Companion_2).n1s = function () {
  return Companion_instance.h1r_1;
};
var Companion_instance_9;
function Companion_getInstance_16() {
  return Companion_instance_9;
}
function SceneManagerCacheComponent(entitiesInScene) {
  this.entitiesInScene = entitiesInScene;
  this.s3j_1 = false;
}
protoOf(SceneManagerCacheComponent).t3j = function () {
  return this.entitiesInScene;
};
protoOf(SceneManagerCacheComponent).p1s = function () {
  return Companion_instance_9.id;
};
protoOf(SceneManagerCacheComponent).eq = function (other) {
  return false;
};
protoOf(SceneManagerCacheComponent).s1s = function () {
  return this.s3j_1;
};
protoOf(SceneManagerCacheComponent).tf = function () {
  return this.entitiesInScene;
};
protoOf(SceneManagerCacheComponent).w2s = function (entitiesInScene) {
  return new SceneManagerCacheComponent(entitiesInScene);
};
protoOf(SceneManagerCacheComponent).copy = function (entitiesInScene, $super) {
  entitiesInScene = entitiesInScene === VOID ? this.entitiesInScene : entitiesInScene;
  return this.w2s(entitiesInScene);
};
protoOf(SceneManagerCacheComponent).toString = function () {
  return 'SceneManagerCacheComponent(entitiesInScene=' + toString(this.entitiesInScene) + ')';
};
protoOf(SceneManagerCacheComponent).hashCode = function () {
  return hashCode(this.entitiesInScene);
};
protoOf(SceneManagerCacheComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SceneManagerCacheComponent))
    return false;
  var tmp0_other_with_cast = other instanceof SceneManagerCacheComponent ? other : THROW_CCE();
  if (!equals(this.entitiesInScene, tmp0_other_with_cast.entitiesInScene))
    return false;
  return true;
};
function SceneManagerEntitiesCache$clearCache$ref($boundThis) {
  var l = function () {
    $boundThis.w3j();
    return Unit_instance;
  };
  l.callableName = 'clearCache';
  return l;
}
function SceneManagerEntitiesCache(holderEntity, entityManager) {
  this.u3j_1 = holderEntity;
  var tmp = this;
  tmp.v3j_1 = new SceneManagerCacheClearingSystem(SceneManagerEntitiesCache$clearCache$ref(this));
  this.v3j_1.l2d(entityManager);
  this.v3j_1.enable();
}
protoOf(SceneManagerEntitiesCache).x3j = function (newValue) {
  var cache = this.u3j_1.__getComponentForKotlin(Companion_instance_9.id);
  var tmp;
  if (cache == null) {
    var entitiesInScene = newValue();
    this.u3j_1.addComponentInternal(new SceneManagerCacheComponent(entitiesInScene));
    tmp = entitiesInScene;
  } else {
    tmp = cache.entitiesInScene;
  }
  return tmp;
};
protoOf(SceneManagerEntitiesCache).w3j = function () {
  this.u3j_1.removeComponentInternal(Companion_instance_9.id);
};
function getFromCacheOrHierarchy($this) {
  return $this.b3k_1.x3j(SceneManagerImpl$getFromCacheOrHierarchy$lambda($this));
}
function replaceScene($this, newScene) {
  if (!$this.z3j_1.isDisposed) {
    $this.y3j_1.disposeEntity($this.z3j_1);
  }
  $this.z3j_1 = newScene;
}
function createRoot($this) {
  var root = $this.y3j_1.createEntity();
  root.addComponent(new DisplayNameComponent('root'));
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  root.addComponent(new ParentComponent(tmp$ret$0));
  root.addComponent(new StaticComponent());
  return root;
}
function addSceneComponents($this, scene) {
  scene.addComponent(new DisplayNameComponent('scene'));
  scene.addComponent(new StaticComponent());
  scene.addComponent(SceneComponent_instance);
  scene.addComponent(new InSceneComponent());
}
function createScene($this) {
  var space = $this.y3j_1.createEntity();
  addSceneComponents($this, space);
  return space;
}
function loadSceneGraph($this, newRoot, bundle, coreServices) {
  var extractedRoots = coreServices.serializer.deserializeToEntityHierarchies(bundle, coreServices);
  if (!(extractedRoots.length === 1))
    return Unit_instance;
  var extractedRoot = first(extractedRoots);
  var newScene = Companion_instance_11.c3k(extractedRoots);
  if (newScene == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    Companion_instance_4.h1l(newScene, newRoot);
    addSceneComponents($this, newScene);
    replaceScene($this, newScene);
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_children(extractedRoot);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.loadSceneGraph.<anonymous>' call
    Companion_instance_4.h1l(element, newRoot);
  }
  var tmp1_safe_receiver = get_parentComponent(newRoot);
  var rootChildren = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = get_hierarchy($this.scene);
  var inductionVariable_0 = 0;
  var last_0 = indexedObject_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = indexedObject_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.loadSceneGraph.<anonymous>' call
    element_0.addComponent(new InSceneComponent());
  }
  var tmp;
  if (rootChildren == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var inductionVariable_1 = 0;
    var last_1 = rootChildren.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = rootChildren[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.loadSceneGraph.<anonymous>' call
      if (element_1.hasComponent(SceneComponent_instance.id)) {
        count = count + 1 | 0;
      }
    }
    tmp = count;
  }
  var tmp3_elvis_lhs = tmp;
  var numScenes = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
  if (numScenes > 1) {
    var tmp_0 = Companion_getInstance_17().d3k_1;
    tmp_0.error(SceneManagerImpl$loadSceneGraph$lambda(numScenes));
  }
  if (numScenes === 0) {
    var tmp_1 = Companion_getInstance_17().d3k_1;
    tmp_1.error(SceneManagerImpl$loadSceneGraph$lambda_0);
  }
  extractedRoot.dispose();
}
function Companion_3() {
  Companion_instance_10 = this;
  this.d3k_1 = LoggerState_getInstance().g1v('SceneGraphImpl');
}
var Companion_instance_10;
function Companion_getInstance_17() {
  if (Companion_instance_10 == null)
    new Companion_3();
  return Companion_instance_10;
}
function SceneManagerImpl$getFromCacheOrHierarchy$lambda(this$0) {
  return function () {
    return get_hierarchy(this$0.z3j_1);
  };
}
function SceneManagerImpl$loadSceneGraph$lambda($numScenes) {
  return function () {
    return 'found ' + $numScenes + ' scenes, that is most probably an error';
  };
}
function SceneManagerImpl$loadSceneGraph$lambda_0() {
  return 'Could not find a scene in deserialized json';
}
function SceneManagerImpl(entityManager) {
  Companion_getInstance_17();
  this.y3j_1 = entityManager;
  this.a3k_1 = createRoot(this);
  this.b3k_1 = new SceneManagerEntitiesCache(this.a3k_1, this.y3j_1);
  var newScene = createScene(this);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.<anonymous>' call
  var spaceRot = this.a3k_1;
  var tmp0_safe_receiver = get_parentComponent(spaceRot);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.addChild(newScene);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [newScene];
    tmp = new ParentComponent(tmp$ret$2);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var newParentComponent = tmp;
  spaceRot.addComponent(newParentComponent);
  newScene.addComponent(new ChildComponent(spaceRot));
  this.z3j_1 = newScene;
}
protoOf(SceneManagerImpl).n2k = function () {
  return getFromCacheOrHierarchy(this);
};
protoOf(SceneManagerImpl).s2t = function () {
  return this.z3j_1;
};
protoOf(SceneManagerImpl).t2t = function () {
  return this.a3k_1;
};
protoOf(SceneManagerImpl).save = function (coreServices) {
  var tempRoot = this.y3j_1.createEntity();
  Companion_instance_4.h1l(this.z3j_1, tempRoot);
  tempRoot.addComponentInternal(new SerializableRootComponent());
  try {
    return coreServices.serializer.toJsonString(tempRoot);
  }finally {
    Companion_instance_4.h1l(this.scene, this.a3k_1);
    tempRoot.removeComponentInternal(Companion_getInstance_4().c39_1);
    this.y3j_1.disposeEntity(tempRoot);
  }
};
protoOf(SceneManagerImpl).load = function (bundle, coreServices) {
  this.b3k_1.w3j();
  var tmp0_safe_receiver = coreServices.coreModules.history();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.clear();
  }
  this.a3k_1.addComponent(new SceneReloadingComponent());
  this.clearScene();
  loadSceneGraph(this, this.a3k_1, bundle, coreServices);
  this.a3k_1.removeComponent(Companion_instance_5.id);
};
protoOf(SceneManagerImpl).clearScene = function () {
  this.b3k_1.w3j();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = reversed(get_descendants(this.scene)).k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.clearScene.<anonymous>' call
    this.y3j_1.disposeEntity(element);
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.scene.components();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element_0 = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.clearScene.<anonymous>' call
    this.scene.removeComponent(element_0.typeId);
  }
  Companion_instance_4.h1l(this.scene, this.root);
  addSceneComponents(this, this.scene);
};
protoOf(SceneManagerImpl).findEntity = function (id) {
  if (id === this.a3k_1.id)
    return this.a3k_1;
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var space = this.scene;
  if (id === space.id)
    return space;
  var tmp0_safe_receiver = get_parentComponent(space);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allDescendants();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.SceneManagerImpl.findEntity.<anonymous>.<anonymous>' call
        if (element.id === id) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  return tmp;
};
function Companion_4() {
}
protoOf(Companion_4).c3k = function (roots) {
  var tmp0_elvis_lhs = firstOrNull_0(roots);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var root = tmp;
  var children = get_children(root);
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = children.length;
    while (inductionVariable < last) {
      var element = children[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.Companion.findSceneFromDeserializedEntityTrees.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_5().g39_1)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var entityWithSerializableSceneComponent = tmp$ret$1;
  if (!(entityWithSerializableSceneComponent == null)) {
    entityWithSerializableSceneComponent.removeComponent(Companion_getInstance_5().g39_1);
    return entityWithSerializableSceneComponent;
  }
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_0 = 0;
    var last_0 = children.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = children[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.Companion.findSceneFromDeserializedEntityTrees.<anonymous>' call
      if (element_0.hasComponent(SceneComponent_instance.id)) {
        tmp$ret$4 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$4 = null;
  }
  var entityWithSceneComponent = tmp$ret$4;
  if (!(entityWithSceneComponent == null))
    return entityWithSceneComponent;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable_1 = 0;
  var last_1 = children.length;
  while (inductionVariable_1 < last_1) {
    var element_1 = children[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.findSceneFromDeserializedEntityTrees.<anonymous>' call
    if (!element_1.hasComponent(Companion_getInstance_6().id)) {
      destination.h(element_1);
    }
  }
  var nonProductChildren = destination;
  if (nonProductChildren.o() === 1)
    return first_0(nonProductChildren);
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_hierarchy(root);
  var tmp$ret$10;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_2 = 0;
    var last_2 = this_0.length;
    while (inductionVariable_2 < last_2) {
      var element_2 = this_0[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.Companion.findSceneFromDeserializedEntityTrees.<anonymous>' call
      if (element_2.hasComponent(Companion_instance.w1o_1) || element_2.hasComponent(Companion_instance.k1o_1) || element_2.hasComponent(Companion_instance.n1p_1)) {
        tmp$ret$10 = element_2;
        break $l$block_1;
      }
    }
    tmp$ret$10 = null;
  }
  var room = tmp$ret$10;
  var roomParent = room == null ? null : get_parent(room);
  if (!(roomParent == null))
    return roomParent;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = nonProductChildren.k();
  while (tmp0_iterator.m()) {
    var element_3 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.hierarchies.Companion.findSceneFromDeserializedEntityTrees.<anonymous>' call
    var tmp$ret$13;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = get_descendants(element_3);
      var inductionVariable_3 = 0;
      var last_3 = indexedObject.length;
      while (inductionVariable_3 < last_3) {
        var element_4 = indexedObject[inductionVariable_3];
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.Companion.findSceneFromDeserializedEntityTrees.<anonymous>.<anonymous>' call
        if (element_4.hasComponent(Companion_getInstance_6().id)) {
          tmp$ret$13 = true;
          break $l$block_2;
        }
      }
      tmp$ret$13 = false;
    }
    if (tmp$ret$13) {
      destination_0.h(element_3);
    }
  }
  var nonProductChildrenWithProductDescendants = destination_0;
  if (nonProductChildrenWithProductDescendants.o() === 1)
    return first_0(nonProductChildrenWithProductDescendants);
  if (nonProductChildrenWithProductDescendants.o() > 1)
    return null;
  return null;
};
protoOf(Companion_4).e3k = function (roots) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = roots.length;
    while (inductionVariable < last) {
      var element = roots[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.Companion.findRootFromDeserializedEntityTrees.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_4().c39_1)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var entityWithRootComponent = tmp$ret$1;
  if (!(entityWithRootComponent == null)) {
    entityWithRootComponent.removeComponent(Companion_getInstance_4().c39_1);
    return entityWithRootComponent;
  }
  return first(roots);
};
var Companion_instance_11;
function Companion_getInstance_18() {
  return Companion_instance_11;
}
function findSceneFromDeserializedEntityTrees(roots) {
  return Companion_instance_11.c3k(roots);
}
function findRootFromDeserializedEntityTrees(roots) {
  return Companion_instance_11.e3k(roots);
}
function SceneSerializationUtil() {
}
function localTransformationComponent($this, json) {
  return Companion_getInstance_7().x1s(json);
}
function worldTransformationComponent($this, json) {
  return Companion_getInstance_8().x1s(json);
}
function assemblyPartsComponent($this, json) {
  return Companion_getInstance_0().x1s(json);
}
function automaticGroupComponent($this, json) {
  return Companion_getInstance_9().fromJson();
}
function productPartComponent($this, json) {
  return Companion_getInstance_10().fromJson(json);
}
function serializableGuestConnectionsComponent($this, json) {
  return Companion_getInstance_11().x1s(json);
}
function productParamsComponent($this, json) {
  return Companion_getInstance_12().x1s(json);
}
function serializableSceneComponent($this, json) {
  return Companion_getInstance_5().x1s(json);
}
function serializableRootComponent($this, json) {
  return Companion_getInstance_4().f39();
}
function CoreComponentDeserializer$localTransformationComponent$ref($boundThis) {
  var l = function (p0) {
    return localTransformationComponent($boundThis, p0);
  };
  l.callableName = 'localTransformationComponent';
  return l;
}
function CoreComponentDeserializer$worldTransformationComponent$ref($boundThis) {
  var l = function (p0) {
    return worldTransformationComponent($boundThis, p0);
  };
  l.callableName = 'worldTransformationComponent';
  return l;
}
function CoreComponentDeserializer$automaticGroupComponent$ref($boundThis) {
  var l = function (p0) {
    return automaticGroupComponent($boundThis, p0);
  };
  l.callableName = 'automaticGroupComponent';
  return l;
}
function CoreComponentDeserializer$assemblyPartsComponent$ref($boundThis) {
  var l = function (p0) {
    return assemblyPartsComponent($boundThis, p0);
  };
  l.callableName = 'assemblyPartsComponent';
  return l;
}
function CoreComponentDeserializer$productPartComponent$ref($boundThis) {
  var l = function (p0) {
    return productPartComponent($boundThis, p0);
  };
  l.callableName = 'productPartComponent';
  return l;
}
function CoreComponentDeserializer$serializableGuestConnectionsComponent$ref($boundThis) {
  var l = function (p0) {
    return serializableGuestConnectionsComponent($boundThis, p0);
  };
  l.callableName = 'serializableGuestConnectionsComponent';
  return l;
}
function CoreComponentDeserializer$productParamsComponent$ref($boundThis) {
  var l = function (p0) {
    return productParamsComponent($boundThis, p0);
  };
  l.callableName = 'productParamsComponent';
  return l;
}
function CoreComponentDeserializer$serializableSceneComponent$ref($boundThis) {
  var l = function (p0) {
    return serializableSceneComponent($boundThis, p0);
  };
  l.callableName = 'serializableSceneComponent';
  return l;
}
function CoreComponentDeserializer$serializableRootComponent$ref($boundThis) {
  var l = function (p0) {
    return serializableRootComponent($boundThis, p0);
  };
  l.callableName = 'serializableRootComponent';
  return l;
}
function CoreComponentDeserializer() {
  this.f3k_1 = true;
  var tmp = this;
  var tmp_0 = Companion_getInstance_7().serializationKey;
  var tmp_1 = to(tmp_0, CoreComponentDeserializer$localTransformationComponent$ref(this));
  var tmp_2 = Companion_getInstance_8().serializationKey;
  var tmp_3 = to(tmp_2, CoreComponentDeserializer$worldTransformationComponent$ref(this));
  var tmp_4 = Companion_getInstance_9().serializationKey;
  var tmp_5 = to(tmp_4, CoreComponentDeserializer$automaticGroupComponent$ref(this));
  var tmp_6 = Companion_getInstance_0().serializationKey;
  var tmp_7 = to(tmp_6, CoreComponentDeserializer$assemblyPartsComponent$ref(this));
  var tmp_8 = Companion_getInstance_10().serializationKey;
  var tmp_9 = to(tmp_8, CoreComponentDeserializer$productPartComponent$ref(this));
  var tmp_10 = Companion_getInstance_11().t38_1;
  var tmp_11 = to(tmp_10, CoreComponentDeserializer$serializableGuestConnectionsComponent$ref(this));
  var tmp_12 = to('params', CoreComponentDeserializer$productParamsComponent$ref(this));
  var tmp_13 = Companion_getInstance_5().h39_1;
  var tmp_14 = to(tmp_13, CoreComponentDeserializer$serializableSceneComponent$ref(this));
  var tmp_15 = Companion_getInstance_4().d39_1;
  tmp.g3k_1 = mapOf([tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, tmp_12, tmp_14, to(tmp_15, CoreComponentDeserializer$serializableRootComponent$ref(this))]);
}
protoOf(CoreComponentDeserializer).s1t = function () {
  return this.f3k_1;
};
protoOf(CoreComponentDeserializer).canHandle = function (serializationKey) {
  return this.g3k_1.d2(serializationKey);
};
protoOf(CoreComponentDeserializer).deserialize = function (serializationKey, json) {
  var tmp0_elvis_lhs = this.g3k_1.f2(serializationKey);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$(toString(''));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp(json);
};
function validateAndCollectResults($this, entity, earlyOut) {
  onValidationStarted($this, entity, false);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.h3k_1;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
    if (element.isEnabled) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var index = 0;
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i = checkIndexOverflow(tmp1);
    var id$delegate = lazy(ValidationServiceImpl$validateAndCollectResults$lambda(i, item));
    var tmp0_safe_receiver = $this.i3k_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t3g(validateAndCollectResults$_anonymous_$lambda$0_ahocsf(id$delegate));
    }
    var result = item.validateCurrentState(entity);
    var tmp1_safe_receiver = $this.i3k_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.n3i(validateAndCollectResults$_anonymous_$lambda$0_ahocsf(id$delegate), ValidationMode_STATE_getInstance());
    }
    var tmp;
    if (earlyOut) {
      tmp = equals(result == null ? null : result.resultType, ValidationResultType_FAIL_getInstance());
    } else {
      tmp = false;
    }
    if (tmp) {
      onValidationFinished($this, entity, false);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return [result];
    }
    destination_0.h(result);
  }
  var this_1 = filterNotNull(destination_0);
  var results = copyToArray(this_1);
  onValidationFinished($this, entity, false);
  var tmp_0;
  // Inline function 'kotlin.collections.isEmpty' call
  if (results.length === 0) {
    tmp_0 = $this.l3k_1;
  } else {
    tmp_0 = results;
  }
  return tmp_0;
}
function validateAndCollectResults_0($this, snap, earlyOut) {
  onValidationStarted($this, snap.guest, true);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.h3k_1;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
    if (element.isEnabled) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var index = 0;
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateAndCollectResults.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i = checkIndexOverflow(tmp1);
    var id$delegate = lazy(ValidationServiceImpl$validateAndCollectResults$lambda_0(i, item));
    var tmp0_safe_receiver = $this.i3k_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t3g(validateAndCollectResults$_anonymous_$lambda$1_ahocse(id$delegate));
    }
    var result = item.validateSnap(snap);
    var tmp1_safe_receiver = $this.i3k_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.n3i(validateAndCollectResults$_anonymous_$lambda$1_ahocse(id$delegate), ValidationMode_SNAP_getInstance());
    }
    var tmp;
    if (earlyOut) {
      tmp = equals(result == null ? null : result.resultType, ValidationResultType_FAIL_getInstance());
    } else {
      tmp = false;
    }
    if (tmp) {
      onValidationFinished($this, snap.guest, true);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return [result];
    }
    destination_0.h(result);
  }
  var this_1 = filterNotNull(destination_0);
  var results = copyToArray(this_1);
  onValidationFinished($this, snap.guest, true);
  var tmp_0;
  // Inline function 'kotlin.collections.isEmpty' call
  if (results.length === 0) {
    tmp_0 = $this.l3k_1;
  } else {
    tmp_0 = results;
  }
  return tmp_0;
}
function onValidationStarted($this, entity, isSnap) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.j3k_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.onValidationStarted.<anonymous>' call
    element(entity, isSnap);
  }
}
function onValidationFinished($this, entity, isSnap) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.k3k_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.onValidationFinished.<anonymous>' call
    element(entity, isSnap);
  }
}
function hasNoErrorsInResult($this, results) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var inductionVariable = 0;
    var last = results.length;
    while (inductionVariable < last) {
      var element = results[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.hasNoErrorsInResult.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return !tmp$ret$1;
}
function Companion_5() {
  Companion_instance_12 = this;
  this.m3k_1 = LoggerState_getInstance().g1v('ValidationServiceImpl');
}
var Companion_instance_12;
function Companion_getInstance_19() {
  if (Companion_instance_12 == null)
    new Companion_5();
  return Companion_instance_12;
}
function validateAndCollectResults$_anonymous_$lambda$0_ahocsf($id$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('id', KProperty0, false, function () {
    return THROW_ISE();
  });
  return $id$delegate.c2();
}
function validateAndCollectResults$_anonymous_$lambda$1_ahocse($id$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('id', KProperty0, false, function () {
    return THROW_ISE();
  });
  return $id$delegate.c2();
}
function ValidationServiceImpl$register$lambda($validation) {
  return function () {
    return "Validation with id '" + $validation.id + "' is already registered";
  };
}
function ValidationServiceImpl$validateAndCollectResults$lambda($i, $rule) {
  return function () {
    return '' + $i + '. ' + $rule.id;
  };
}
function ValidationServiceImpl$validateAndCollectResults$lambda_0($i, $rule) {
  return function () {
    return '' + $i + '. ' + $rule.id;
  };
}
function ValidationServiceImpl() {
  Companion_getInstance_19();
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.h3k_1 = [];
  this.i3k_1 = null;
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_0.j3k_1 = ArrayList_init_$Create$();
  var tmp_1 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_1.k3k_1 = ArrayList_init_$Create$();
  var tmp_2 = this;
  // Inline function 'kotlin.emptyArray' call
  tmp_2.l3k_1 = [];
}
protoOf(ValidationServiceImpl).q3h = function (_set____db54di) {
  this.i3k_1 = _set____db54di;
};
protoOf(ValidationServiceImpl).r3h = function () {
  return this.i3k_1;
};
protoOf(ValidationServiceImpl).g1k = function () {
  return this.h3k_1;
};
protoOf(ValidationServiceImpl).register = function (validation) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.h3k_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.system.ValidationServiceImpl.register.<anonymous>' call
      if (element.id === validation.id) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    var tmp = Companion_getInstance_19().m3k_1;
    tmp.warn(ValidationServiceImpl$register$lambda(validation));
  }
  var tmp_0 = this;
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = this.h3k_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [validation];
  tmp_0.h3k_1 = tmp$ret$2.concat(tmp$ret$5);
};
protoOf(ValidationServiceImpl).unregister = function (validation) {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = minus(toMutableList(this.h3k_1), validation);
  tmp.h3k_1 = copyToArray(this_0);
};
protoOf(ValidationServiceImpl).s3h = function (listener) {
  // Inline function 'kotlin.collections.plusAssign' call
  this.j3k_1.h(listener);
};
protoOf(ValidationServiceImpl).t3h = function (listener) {
  // Inline function 'kotlin.collections.plusAssign' call
  this.k3k_1.h(listener);
};
protoOf(ValidationServiceImpl).u3h = function (listener) {
  // Inline function 'kotlin.collections.minusAssign' call
  this.j3k_1.j2(listener);
};
protoOf(ValidationServiceImpl).v3h = function (listener) {
  // Inline function 'kotlin.collections.minusAssign' call
  this.k3k_1.j2(listener);
};
protoOf(ValidationServiceImpl).x3h = function (snap, earlyOut) {
  snap.performMove();
  var result = validateAndCollectResults_0(this, snap, earlyOut);
  snap.rollbackMove();
  return new SnapValidationResult(snap, result);
};
protoOf(ValidationServiceImpl).y3h = function (snap, earlyOut) {
  return this.validateSnapCandidate(snap, earlyOut).errorsAndWarnings;
};
protoOf(ValidationServiceImpl).z3h = function (snaps, earlyOut) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(snaps.length);
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var item = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateSnapCandidates.<anonymous>' call
    var tmp$ret$0 = this.validateSnapCandidate(item, earlyOut);
    destination.h(tmp$ret$0);
  }
  return copyToArray(destination);
};
protoOf(ValidationServiceImpl).a3i = function (snaps, earlyOut) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = this.validateSnapCandidates(snaps, earlyOut);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.validateSnaps.<anonymous>' call
    var list = toList(element.errorsAndWarnings);
    addAll(destination, list);
  }
  return copyToArray(destination);
};
protoOf(ValidationServiceImpl).w3h = function (entity, earlyOut) {
  return validateAndCollectResults(this, entity, earlyOut);
};
protoOf(ValidationServiceImpl).b3i = function (snaps, sortByWarnings) {
  // Inline function 'kotlin.emptyArray' call
  var allErrors = [];
  var firstWarning = null;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var element = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.system.ValidationServiceImpl.getFirstValidSnap.<anonymous>' call
    element.performMove();
    var errorsAndWarnings = validateAndCollectResults_0(this, element, true);
    // Inline function 'kotlin.collections.isEmpty' call
    var snapWasGood = errorsAndWarnings.length === 0;
    if (snapWasGood) {
      element.rollbackMove();
      return new ValidSnapActionCandidateOrErrors(element);
    }
    var snapWasOk = hasNoErrorsInResult(this, errorsAndWarnings);
    if (snapWasOk) {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = errorsAndWarnings.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = errorsAndWarnings[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.system.ValidationServiceImpl.getFirstValidSnap.<anonymous>.<anonymous>' call
        if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
          destination.h(element_0);
        }
      }
      var myWarnings = destination;
      var tmp;
      if (firstWarning == null) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.count' call
        tmp = ensureNotNull(firstWarning).warnings.length > myWarnings.o();
      }
      if (tmp) {
        if (sortByWarnings) {
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$6 = copyToArray(myWarnings);
          firstWarning = new ValidSnapActionCandidateOrErrors(element, tmp$ret$6);
        } else {
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$7 = copyToArray(myWarnings);
          return new ValidSnapActionCandidateOrErrors(element, tmp$ret$7);
        }
      }
    }
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    allErrors = allErrors.concat(errorsAndWarnings);
  }
  var tmp0_safe_receiver = lastOrNull(snaps);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.rollbackMove();
  }
  var tmp1_elvis_lhs = firstWarning;
  return tmp1_elvis_lhs == null ? new ValidSnapActionCandidateOrErrors(null, VOID, allErrors) : tmp1_elvis_lhs;
};
//region block: post-declaration
protoOf(CoreImpl).setLogModule = setLogModule;
protoOf(CoreImpl).addHistoryModule = addHistoryModule;
defineProp(protoOf(CoreImpl), 'services', function () {
  return this.z1j();
});
defineProp(protoOf(CoreImpl), 'modules', function () {
  return this.a1k();
});
protoOf(ProductManagerImpl).createEntity = createEntity;
protoOf(ProductManagerImpl).createEntityInternal = createEntityInternal;
protoOf(ProductManagerImpl).productSpecification = productSpecification;
protoOf(ProductManagerImpl).createFromSpecification = createFromSpecification;
protoOf(ProductManagerImpl).createFromSpecificationInternal = createFromSpecificationInternal;
defineProp(protoOf(ProductManagerImpl), 'catalogs', function () {
  return this.x1t();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SceneManagerCacheClearingSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Companion_2), 'id', protoOf(Companion_2).n1s);
protoOf(SceneManagerCacheComponent).r1s = get_serializable;
defineProp(protoOf(SceneManagerCacheComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SceneManagerCacheComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SceneManagerCacheComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SceneManagerImpl), 'entities', function () {
  return this.n2k();
});
defineProp(protoOf(SceneManagerImpl), 'scene', function () {
  return this.s2t();
});
defineProp(protoOf(SceneManagerImpl), 'root', function () {
  return this.t2t();
});
defineProp(protoOf(CoreComponentDeserializer), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
  return this.s1t();
});
protoOf(ValidationServiceImpl).validateSnapCandidate = validateSnapCandidate;
protoOf(ValidationServiceImpl).validateSnap = validateSnap;
protoOf(ValidationServiceImpl).validateSnapCandidates = validateSnapCandidates;
protoOf(ValidationServiceImpl).validateSnaps = validateSnaps;
protoOf(ValidationServiceImpl).validateCurrentState = validateCurrentState;
protoOf(ValidationServiceImpl).getFirstValidSnap = getFirstValidSnap;
defineProp(protoOf(ValidationServiceImpl), 'validations', function () {
  return this.g1k();
});
//endregion
//region block: init
Companion_instance_8 = new Companion_1();
Companion_instance_9 = new Companion_2();
Companion_instance_11 = new Companion_4();
//endregion
//region block: exports
defineProp(SystemGraphViewer, 'Companion', Companion_getInstance_14);
defineProp(SceneManagerCacheComponent, 'Companion', Companion_getInstance_16);
SceneSerializationUtil.findSceneFromDeserializedEntityTrees = findSceneFromDeserializedEntityTrees;
SceneSerializationUtil.findRootFromDeserializedEntityTrees = findRootFromDeserializedEntityTrees;
defineProp(SceneSerializationUtil, 'Companion', Companion_getInstance_18);
defineProp(ValidationServiceImpl, 'Companion', Companion_getInstance_19);
export {
  CoreImpl as CoreImpl,
  SystemGraphViewer as SystemGraphViewer,
  SceneManagerCacheComponent as SceneManagerCacheComponent,
  SceneSerializationUtil as SceneSerializationUtil,
  ValidationServiceImpl as ValidationServiceImpl,
};
export {
  CoreImpl as CoreImpl8in9la2y2fyb,
};
//endregion

//# sourceMappingURL=core-core-kernel.mjs.map
